<template>
  <div>
    <message-modal />
    <div>
      <main-header />
      <parcel-filter filter-name="exportProof" />
      <export-proof-detail-header />
      <export-proof-detail-table v-if="!isLoading" />
    </div>
    <div v-if="isLoading" class="spl-load-img" />
  </div>
</template>

<script>
import Helpers from '@/helpers'
import { cloneDeep } from 'lodash'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'

export default {
  name: 'ExportProofDetail',
  mixins: [Helpers],
  data () {
    return {
      isLoading: false
    }
  },
  computed: {
    ...mapGetters('exportProof', ['loadedExportProof']),
    ...mapState('parcelFilter', ['currentExportProofFilter'])
  },
  watch: {
    currentExportProofFilter: {
      handler: function () {
        this.isLoading = true
        // Everytime we change the parcel filter we set it to the loaded export proof and execute the export proof again
        var exportProof = cloneDeep(this.loadedExportProof)
        exportProof.Export_Proof_Filter = cloneDeep(this.currentExportProofFilter)
        this.setLoadedExportProof(exportProof)
        this.executeExportProof(this.loadedExportProof).then(() => {
          this.isLoading = false
        }).catch(() => {
          this.isLoading = false
        })
      },
      deep: true
    }
  },
  created () {
    this.isLoading = true
    this.loadExportProof(this.$route.params.id).then(() => {
      // on startup load the export proof then set the parcelFilter from the loaded export proof this executes it directly
      this.setParcelFilter({ parcelFilter: this.loadedExportProof.Export_Proof_Filter, filterName: 'exportProof' })
    }).catch(() => {
      this.isLoading = false
    })
  },
  methods: {
    ...mapActions('exportProof', ['loadExportProof', 'executeExportProof']),
    ...mapMutations('parcelFilter', ['setParcelFilter']),
    ...mapMutations('exportProof', ['setLoadedExportProof']),
    // *********************** SEARCH *************************
    search_Clicked (searchValue) {
      // this.$router.push('/parcel-list?search=' + encodeURIComponent(searchValue) );
    }
  }
}
</script>

<style>

</style>
